<template>

  <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-calendar3 display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            GESTION DE PERIODO
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            APERTURA / CIERRE
          </p>
        </div>
      </div>
    </div>
    <div class="border border-1 rounded-3 p-3 mb-2">
      <div class="row align-items-end g-3">

        <!-- AÑO -->
        <div class="col-md-3">
          <label class="form-label tamaño">AÑO:</label>
          <input type="number" class="form-control" placeholder="INGRESAR EL AÑO" v-model="año" @input="limitarLongitud"
            max="3000" min="2000" />
        </div>

        <!-- MES -->
        <div class="col-md-3">
          <label class="form-label tamaño">MES:</label>
          <input type="number" class="form-control" placeholder="INGRESAR EL MES" v-model="mes" @input="limitarLongitud"
            max="12" />
        </div>

        <!-- BOTÓN GUARDAR -->
        <div class="col-md-2 d-flex align-items-end">
          <button class="btn btn-success " @click="PostListado">
            <i class="bi bi-floppy"></i>
          </button>
        </div>
      </div>
    </div>


    <div class="border border-1 rounded-3 p-3 mb-2">
      <div class="row align-items-center mt-2 mx-2 ">

        <!-- 🔍 BUSCADOR A LA IZQUIERDA -->
        <div class="col-md-6 d-flex">
          <div class="input-group" style="max-width: 350px; width: 100%;">
            <span class="input-group-text mb-2">
              <i class="bi bi-search"></i>
            </span>
            <input class="form-control mb-2" type="text" placeholder="Año o Mes..." v-model="searchQuery" />
          </div>
        </div>

        <!-- ⚠️ ADVERTENCIA A LA DERECHA -->
        <div class="col-md-6 d-flex justify-content-end">
          <div class="border border-danger text-danger fw-semibold px-3 py-2 shadow-sm" style="border-radius: 8px;">
            <i class="bi bi-info-circle me-2"></i>
            SOLO SE PUEDE TENER UN PERIODO ABIERTO A LA VEZ
          </div>
        </div>

      </div>

      <div class="table-responsive mx-2 mt-2">

        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col">AÑO</th>
              <th scope="col">MES</th>
              <th scope="col">RENOVACION (*)</th>
              <th scope="col">CESE (*)</th>
              <th scope="col">ELIMINAR</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="loading">
              <td colspan="5" class="text-center align-middle" style="height: 260px;">
                <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                  <div class="spinner-border text-warning" style="width: 3.5rem; height: 3.5rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                </div>
              </td>
            </tr>

            <tr class="text-center align-middle reducirTamaño" v-else v-for="items in paginatedPeriodo" :key="items.id">
              <td class="text-center"> {{ items.año }} </td>

              <td class="text-center"> {{ items.mes }} </td>

              <td class="text-center">
                <button :disabled="items.canRenovacion > 0 && !items.renovacion" :class="{
                  'btn btn-success boton-estiloCuadrado':
                    !items.renovacion,
                  'btn btn-warning boton-estiloCuadrado':
                    items.renovacion,
                }" @click="CambiarEstadoRenovacion(items.idPeriodo)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-lock"
                    viewBox="0 0 16 16">
                    <path v-if="!items.renovacion"
                      d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />

                    <path v-else
                      d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z" />
                  </svg>
                </button>
              </td>
              <td class="text-center">
                <button :disabled="items.canCese > 0 && !items.cese" :class="{
                  'btn btn-success  boton-estiloCuadrado':
                    !items.cese,
                  'btn btn-warning  boton-estiloCuadrado':
                    items.cese,
                }" @click="CambiarEstadoCese(items.idPeriodo)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-lock"
                    viewBox="0 0 16 16">
                    <path v-if="!items.cese"
                      d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />

                    <path v-else
                      d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z" />
                  </svg>
                </button>
              </td>

              <td class="text-center">
                <button @click="Eliminar(items.idPeriodo)" class="btn btn-outline-danger boton-estiloCuadrado">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-trash3" viewBox="0 0 16 16">
                    <path
                      d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!--
                <div class="d-flex mt-3">
                    <button
                        class="btn boton-estiloPag"
                        @click="retroceso"
                        :disabled="noRetroceder"
                    >
                        <span aria-hidden="true">{{ retroceder }}</span>
                    </button>
                    <button
                        class="boton-estiloPag reducirTamaño"
                        :disabled="true"
                    >
                        {{ pag }} / {{ Math.ceil(this.Items.length / 25) }}
                    </button>

                    <button
                        class="btn boton-estiloPag"
                        @click="aumentar"
                        :disabled="noAvanzar"
                    >
                        <span aria-hidden="true">{{ avanzar }}</span>
                    </button>
                </div>
  -->
      </div>

    </div>
    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>

      <span class="pagination-info small fw-semibold text-secondary">
        Página {{ currentPage }} de {{ totalPages }}
      </span>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
        :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>

  </div>

</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "SolimanologGestionDePeriodo",

  data() {
    return {
      año: 2023,
      mes: null,
      ItemsPeriodo: [],
      currentPage: 1,
      itemsPerPage: 10,
      loading: false,
      searchQuery: "",

    };
  },

  computed: {
    filteredPeriodo() {
      if (!this.searchQuery) return this.ItemsPeriodo;

      const q = this.searchQuery.toLowerCase();

      return this.ItemsPeriodo.filter((i) =>
        i.año.toString().includes(q) ||
        i.mes.toString().includes(q)
      );
    },

    paginatedPeriodo() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredPeriodo.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredPeriodo.length / this.itemsPerPage);
    },
  },
  watch: {
    searchQuery() {
      this.loading = true;

      // Simulación de carga (200–300 ms)
      setTimeout(() => {
        this.loading = false;
        this.currentPage = 1; // volver a la primera página
      }, 800);
    }
  },

  mounted() { },

  created() {
    this.getAttributes();
  },

  methods: {
    getAttributes() {
      this.oading = true;
      this.axios.get(`Periodo/ListarPeriodo`).then((r) => {
        this.ItemsPeriodo = r.data;
        console.log(r.data);
      })
        .finally(() => {
          this.loading = false;
        });
    },

    limitarLongitud() {
      if (this.año && this.año.toString().length > 4) {
        this.año = parseInt(this.año.toString().substring(0, 4));
      }

      if (this.mes && this.mes.toString().length > 2) {
        this.mes = parseInt(this.mes.toString().substring(0, 2));
      }

      // Limitar al máximo de 3000
      if (this.año > 3000) {
        this.año = 3000;
      }

      if (this.mes > 12) {
        this.mes = 12;
      }
    },

    CambiarEstadoRenovacion(id) {
            console.log(id)

      this.axios.put(`Periodo/EstadoRenovacion?idPeriodo=${id}`).then((r) => {
        if (r.data) {
          this.getAttributes();
        }
      });
    },

    

    // CambiarEstadoCese(id) {
    //   console.log(id)
    //   // this.axios.put(`Periodo/EstadoCese?idPeriodo=${id}`).then((r) => {
    //   //   if (r.data) {
    //   //     this.getAttributes();
    //   //   }
    //   // });
    // },

    PostListado() {
      const from = {
        año: `${this.año}`,
        mes: `${this.mes}`,
      };

      console.log(from);
      this.axios
        .post(`Periodo/Registrar`, from)
        .then((r) => {
          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "SE REGISTRO",
              showConfirmButton: false,
              timer: 1500,
            });
            this.getAttributes();
            this.año = null;
            this.mes = null;
          }
        })
        .catch((error) => {
          console.log(error.response.data);
          if (!error.response.data) {
            Swal.fire({
              icon: "error",
              title: "Ya existe este periodo",
              text: "",
              footer: "",
            });
          }
        });
    },


    Eliminar(id) {
      Swal.fire({
        title: "¿Estás seguro de eliminar este período?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete(`Periodo/Eliminar?idPeriodo=${id}`).then((r) => {
            if (r.data) {
              Swal.fire("Eliminado", "", "success");
              this.getAttributes();
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.label-resaltado {
  font-weight: 700;
  font-size: 0.65rem;
}

.tamaño {
  font-size: 0.65rem;
  color: #002c5d;
  font-weight: 500;
}
</style>
